import React, { useEffect, useState } from "react";
import Icon from "../../Icon";
import Tooltip from "../../Tooltip";
import SwapText from "../SwapText";
import { buildHints, HINT_CYCLE_MS } from "../constants";
import { HintRow, HintLink } from "./styles";

/**
 * Cycling helper line beneath the search input
 */
const SearchHintRow = ({
  mode,
  inputValue,
  isFocused,
  visible,
  onModeChange,
  onUploadClick,
  setPlaceholder,
  uploadDisabled = false,
  uploadDisabledReason
}) => {
  const [hints, setHints] = useState(() => buildHints(mode));
  const [step, setStep] = useState(0);
  const [linkHovered, setLinkHovered] = useState(false);

  const done = step >= hints.length - 1;
  const paused = inputValue.length > 0 || isFocused || linkHovered || done;

  useEffect(() => {
    setHints(buildHints(mode));
    setStep(0);
  }, [mode]);

  useEffect(() => {
    if (paused) return undefined;

    const id = setInterval(() => {
      setStep(s => s + 1);
    }, HINT_CYCLE_MS);

    return () => clearInterval(id);
  }, [paused]);

  useEffect(() => {
    setPlaceholder({
      text: hints[step].placeholder,
      key: `${mode}-${step}`
    });
  }, [step, hints, mode, setPlaceholder]);

  const { hint, link } = hints[step];

  return (
    <HintRow $visible={visible} aria-hidden={!visible}>
      <Icon
        type="info_round"
        size="xs"
        inheritColor
        className="hint-icon"
        hoverBackground={false}
      />
      <SwapText swapKey={`${mode}-${step}`}>
        {hint}
        {link && (() => {
          const linkDisabled =
            link.action.type === "openUpload" && uploadDisabled;
          const hintLink = (
            <HintLink
              type="button"
              onMouseDown={(e) => e.preventDefault()}
              onMouseEnter={() => setLinkHovered(true)}
              onMouseLeave={() => setLinkHovered(false)}
              onClick={() => {
                if (linkDisabled) return;
                if (link.action.type === "openUpload") {
                  onUploadClick();
                } else if (link.action.type === "switchMode") {
                  onModeChange(link.action.targetMode);
                }
              }}
              aria-disabled={linkDisabled || undefined}
              $disabled={linkDisabled}
              tabIndex={visible && !linkDisabled ? 0 : -1}
            >
              {link.label}
            </HintLink>
          );
          return linkDisabled && uploadDisabledReason ? (
            <Tooltip title={uploadDisabledReason}>{hintLink}</Tooltip>
          ) : (
            hintLink
          );
        })()}
      </SwapText>
    </HintRow>
  );
};

export default SearchHintRow;
